@if (mainFilename$ | async; as mainFilename) {
  <tkv-angebot-v2
    *axLazyElement="'tkv-angebot-v2/' + mainFilename"
    [dispatcher]="globalEventDispatcher"></tkv-angebot-v2>
}
